import { z } from 'zod';
export const NetworkStatusSchema = z
  .object({
    online: z.number().int().nonnegative(),
    max: z.number().int().nonnegative(),
  })
  .strict();
export type NetworkStatus = z.infer<typeof NetworkStatusSchema>;
